<script lang="ts">
  import { onMount } from 'svelte';
  import { createDialog } from 'svelte-headlessui';
  import { onBeforeClose } from 'svelte-modals';
  import Transition from 'svelte-transition';
  import { Icon } from './index.ts';
  import { ModalFont, type PromptLines } from './modals.ts';
  import { PromptLinesDom } from './prompt_lines_dom.ts';

  // Modals sets this to "is on the top of the modal stack"
  export let isOpen = true;
  export let icon: string | undefined = undefined;
  export let header: string | undefined = undefined;
  export let text: PromptLines | undefined = undefined;
  export let position: 'top' | 'center' | 'bottom' = 'center';
  export let styleClass: string | undefined = undefined;

  const dialog = createDialog({ label: header ?? '' });

  onBeforeClose(() => {
    // console.log('closing');
    dialog.close();
  });

  let cancelButton: HTMLElement | undefined;

  // function focus(node: HTMLButtonElement, action: DialogAction<T>) {
  //   console.log('focus', action);
  //   if (action === cancelAction) {
  //     console.log('focusing', { cancelButton });
  //     node.focus({ preventScroll: true });
  //   }
  // }

  function afterEnter() {
    // console.log('afterEnter focusing', { cancelButton });
    cancelButton?.focus({ preventScroll: true });
  }

  onMount(() => {
    // console.log('opening');
    dialog.open();
    // console.log('onMount focus', { cancelButton });
    // cancelButton?.focus({ preventScroll: true });
  });
</script>

<Transition show={$dialog.expanded && isOpen}>
  <div class="relative z-10">
    <Transition
      enter="ease-out duration-300"
      enterFrom="opacity-0"
      enterTo="opacity-100"
      leave="ease-in duration-200"
      leaveFrom="opacity-100"
      leaveTo="opacity-0"
      on:after-enter={afterEnter}>
      <!-- on:after-enter={afterEnter}> -->
      <div class="fixed inset-0 bg-black/25 transition-opacity" />
    </Transition>

    <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
      <div
        class="flex min-h-full {position === 'top'
          ? 'items-start'
          : position === 'bottom'
            ? 'items-end'
            : 'items-center'} justify-center p-4 text-center sm:items-center sm:p-0">
        <Transition
          enter="ease-out duration-300"
          enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          enterTo="opacity-100 translate-y-0 sm:scale-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100 translate-y-0 sm:scale-100"
          leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
          <div
            use:dialog.modal
            class="{styleClass ??
              ''} {ModalFont} relative transform rounded-lg bg-white text-left shadow-xl transition-all w-full max-w-lg p-4">
            <div class="sm:flex sm:items-start">
              <div class="flex items-start">
                {#if icon}
                  <div class="shrink-0">
                    <Icon {icon} />
                  </div>
                {/if}
                <div class="ml-3 w-0 flex-1 pt-0.5">
                  {#if header}
                    <p class="text-sm font-medium text-gray-900">{header}</p>
                  {/if}
                  <PromptLinesDom lines={text} class="mt-1 text-sm text-gray-700" />
                </div>
              </div>
            </div>
          </div>
        </Transition>
      </div>
    </div>
  </div>
</Transition>

<style lang="scss">
  .downArrowCenter:before {
    content: '';
    position: absolute;
    top: 100%;
    left: calc(50% - 0.75rem);
    width: 0;
    border-top: 1rem solid white;
    border-left: 0.75rem solid transparent;
    border-right: 0.75rem solid transparent;
  }

  .upArrowRight:before {
    content: '';
    position: absolute;
    bottom: 100%;
    left: calc(100% - 2rem);
    width: 0;
    border-bottom: 1rem solid white;
    border-left: 0.75rem solid transparent;
    border-right: 0.75rem solid transparent;
  }
</style>
